const menuLinks = document.querySelectorAll('.second_level_tabs .menu_link a');
if (menuLinks) {
  menuLinks.forEach(menuLink => {
    menuLink.addEventListener('click', event => {
      const active = document.querySelector(
        '.tab_link.active .second_level_tabs .menu_link.active',
      );
      if (active) {
        active.classList.remove('active');
      }
      menuLink.parentElement.classList.add('active');
    });
  });
}

const jumpLinks = document.querySelectorAll('.jump_link a');
if (jumpLinks) {
  jumpLinks.forEach(menuLink => {
    menuLink.addEventListener('click', event => {
      const active = document.querySelector('.jump_link.active');
      if (active) {
        active.classList.remove('active');
      }
      menuLink.parentElement.classList.add('active');
      const navTabLinkList = document.querySelector('.rail .left_rail_wrapper .nav_tab');
      if (navTabLinkList) {
        navTabLinkList.classList.toggle('show_mobile_dropdown');
      }
    });
  });
}

const activeTabLink = document.querySelector('.tab_link.active');
if (activeTabLink) {
  activeTabLink.addEventListener('click', event => {
    event.preventDefault();
    const navTabLinkList = document.querySelector('.rail .left_rail_wrapper .nav_tab');
    if (navTabLinkList) {
      navTabLinkList.classList.toggle('show_mobile_dropdown');
    }
  });
}

document.body.addEventListener('click', event => {
  const myElement = document.querySelector('.show_mobile_dropdown');
  if (myElement && event.target.parentElement.parentElement !== myElement) {
    myElement.classList.remove('show_mobile_dropdown');
    event.preventDefault();
  }
});

const offerPromotions = document.querySelectorAll('.isLoggedOut .body_container .component_wrapper .offers_promoslider .component_wrapper .component_promotions');
if (offerPromotions) {
    offerPromotions.forEach(text => {
        const button = text.querySelector('.fullwidth[data-combo_cta]');
        if (button) {
            const urlParams = new URLSearchParams(button.href);
            const mCategoryId = urlParams.get('mCategoryId');
            if (window.orderViewModel.selectedStoreId) {
                button.href = menuList(
                    window.orderViewModel.headerFooterLanguageCode.toLowerCase(),
                    window.orderViewModel.selectedStoreId,
                    mCategoryId
                );
            }
        }
    });
}

function menuList(language, restaurantId, categoryId) {
    return `${window.location.origin}/${language}/restaurant/${restaurantId}/menu/category/${categoryId}`;
}
